import React, { Component } from 'react';
import { CircularProgress } from 'material-ui-beta/Progress';
import Button from 'material-ui-beta/Button';
import Card from 'material-ui-beta/Card';
import numeral from 'numeral';
const ZonedDateTime = require('js-joda').ZonedDateTime;

import StripeApi from '../../api/StripeApi';
import api from '../../api/api';

import './AdminSubscriptions.css';

class AdminSubscriptions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            subscriptions: null,
        };
    }

    componentDidMount() {
        this.fetchSubscriptions();
    }

    fetchSubscriptions() {
        api.fetchSubscriptions(this.props.user).then(subscriptions => {
            this.setState({
                loading: false,
                subscriptions: subscriptions
            });
        }).catch(err => {
            console.log(err);
            alert('Error fetching subscriptions');
        })
    }

    isUserAdmin() {
        return this.props.user && this.props.user.isAdmin;
    }

    onSubscriptionDeleted = () => {
        this.setState({
            loading: true
        });
        this.fetchSubscriptions();
    }

    render() {
        return (
            <div className="admin-subscriptions-container flex centerBoth padding30">
                <div className="flex flex1 centerBoth">
                    {this.state.loading ?
                        <CircularProgress size={50}/>
                        :
                        <div className="flex column flex1">
                            {this.state.subscriptions.map((subscription, index) => {
                                return (
                                    <Subscription
                                        subscription={subscription}
                                        key={"admin-subscription-" + index}
                                        index={index}
                                        user={this.props.user}
                                        onSubscriptionDeleted={this.onSubscriptionDeleted} />
                                )
                            })}
                            {this.state.subscriptions.length === 0 ?
                                <div className="lato admin-subscriptions-empty">
                                    No Subscriptions to Display.
                                </div>
                                :
                                null
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }

}


class Subscription extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }
    }

    onCancelClick = () => {
        this.setState({
            loading: true
        });
        StripeApi.cancelSubscription(this.props.subscription.stripe_subscription.id).then(confirmation => {
            api.removeSubscription(this.props.user, this.props.subscription.key).then(() => {
                this.setState({
                    loading: false
                });
                this.props.onSubscriptionDeleted();
            });
        }).catch(err => {
            alert('error cancelling subscription')
        });
    };

    getRenewalDate() {
        let purchaseDate = ZonedDateTime.parse(this.props.subscription.subscription.created);
        let credits = this.props.subscription.subscription.item.resource.pricing[this.props.subscription.subscription.item.selectedOption].credits;
        let renewalDate = purchaseDate.plusMonths(credits);
        return `Renews ${renewalDate.monthValue()}/${renewalDate.dayOfMonth()}/${renewalDate.year()}`;
    }

    getPrice() {
        return numeral(this.props.subscription.stripe_subscription.plan.amount / 100.0).format('$0,0.00');
    }

    render() {
        return (
            <div className="admin-subscription-container flex1">
                <Card className="admin-subscription-card padding30 marginTop20">
                    <div className="flex">
                        <div className="flex1 oswald admin-subscription-title">
                            {this.props.subscription.subscription.item.resource.title}
                        </div>
                        <div className="lato admin-subscription-price">
                            {this.getPrice()}
                        </div>
                    </div>
                    <div className="admin-subscription-renews lato">
                        {this.getRenewalDate()}
                    </div>
                    <div className="marginTop30">
                        {this.state.loading ?
                            <CircularProgress size={35} />
                            :
                            <Button onClick={this.onCancelClick} color="secondary">Cancel Subscription</Button>
                        }
                    </div>
                </Card>
            </div>
        )
    }


}

export default AdminSubscriptions;


// WEBPACK FOOTER //
// ./src/components/admin-subscriptions/AdminSubscriptions.js